import { render, staticRenderFns } from "./FatigaEntradaRecepcion.vue?vue&type=template&id=4ffb765b&scoped=true"
import script from "./FatigaEntradaRecepcion.vue?vue&type=script&lang=js"
export * from "./FatigaEntradaRecepcion.vue?vue&type=script&lang=js"
import style0 from "./FatigaEntradaRecepcion.vue?vue&type=style&index=0&id=4ffb765b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffb765b",
  null
  
)

export default component.exports